import { Currency } from '@/Domain/Batch/Currency'

export class BatchEconomicInfo {
  private _appraisal: Currency
  private _taxes: Currency
  private _temporaryDeposit: Currency | null

  constructor (appraisal: Currency, taxes: Currency, temporaryDeposit?: Currency) {
    this._appraisal = appraisal
    this._taxes = taxes
    this._temporaryDeposit = temporaryDeposit !== undefined ? temporaryDeposit : null
  }

  appraisal (): string {
    return this._appraisal.toString()
  }

  taxes (): string {
    return this._taxes.toString()
  }

  temporaryDeposit (): string {
    return this._temporaryDeposit !== null
      ? this._temporaryDeposit.toString()
      : ''
  }
}
